module.exports = __webpack_public_path__ + "img/accessdeniedBG.ebfd0727.png";